import { takeLatest, put, call } from 'redux-saga/effects';
import { storage } from '@commons/storage';

import { getTotais } from '../service';
import { getTotalAreaAtivaNaSafra } from '../../safraCadastro/service';

import {
  CONFIG_SESSION,
  TOTAIS_DASHBOARD,
  TOTAIS_DASHBOARD_PENDING,
  TOTAIS_DASHBOARD_SUCCESS,
  TOTAIS_DASHBOARD_FAILURE,
  GRAFICO_CUSTO_PRODUCAO_TALHAO_DASHBOARD,
  GRAFICO_CUSTO_TIPO_INSUMO_DASHBOARD,
  CUSTO_LIST_PROCEDIMENTOS,
  CUSTO_LIST_DESPESAS_DIRETAS,
  CUSTO_LIST_INSUMOS,
  CUSTO_LIST_MAQUINARIOS,
  CUSTO_LIST_FUNCIONARIOS
} from '@handler';

import { formatDateDDMMYYYY } from '@components/common/format';

function* sagaTotais(action) {
  yield put({ type: TOTAIS_DASHBOARD_PENDING });

  const session = JSON.parse(storage.get(CONFIG_SESSION));
  const idFazenda = session.fazendaSelecionada?.id ?? -1;
  const idSafra = session.safraAtiva?.id ?? -1;
  const dataInicial = formatDateDDMMYYYY(action.dataInicial);
  const dataFinal = formatDateDDMMYYYY(action.dataFinal);

  try {
    const totalAreaAtivaNaSafra = yield call(getTotalAreaAtivaNaSafra, idSafra);
    const totais = yield call(getTotais, idFazenda, idSafra, dataInicial, dataFinal);

    yield put({
      type: TOTAIS_DASHBOARD_SUCCESS,
      totais: {
        ...totais,
        totalAreaAtivaNaSafra
      }
    });
  } catch (error) {
    yield put({ type: TOTAIS_DASHBOARD_FAILURE });
  }

  yield put({ type: GRAFICO_CUSTO_PRODUCAO_TALHAO_DASHBOARD, dataInicial: action.dataInicial, dataFinal: action.dataFinal });
  yield put({ type: GRAFICO_CUSTO_TIPO_INSUMO_DASHBOARD, dataInicial: action.dataInicial, dataFinal: action.dataFinal });

  // Dispara ações para sagas específicas de cada lista
  yield put({ type: CUSTO_LIST_PROCEDIMENTOS, dataInicial: action.dataInicial, dataFinal: action.dataFinal });
  yield put({ type: CUSTO_LIST_DESPESAS_DIRETAS, dataInicial: action.dataInicial, dataFinal: action.dataFinal });
  yield put({ type: CUSTO_LIST_INSUMOS, dataInicial: action.dataInicial, dataFinal: action.dataFinal });
  yield put({ type: CUSTO_LIST_MAQUINARIOS, dataInicial: action.dataInicial, dataFinal: action.dataFinal });
  yield put({ type: CUSTO_LIST_FUNCIONARIOS, dataInicial: action.dataInicial, dataFinal: action.dataFinal });
}

export default function* watchTotais() {
  yield takeLatest(TOTAIS_DASHBOARD, sagaTotais);
}
